import React from "react";
import PropTypes from "prop-types";
const FileIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 20}
    height={height || size || 20}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M6 2h3.757c.796 0 1.56.316 2.122.879L15.12 6.12a3 3 0 01.879 2.122V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2z"
      />
      <path
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M15 8h-5V3"
      />
    </g>
  </svg>
);

FileIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default FileIcon;
